module.exports = __webpack_public_path__ + "imgs/BlazySusan.c482a470705d94305648a501a34cd392.png";